"use client";

import { useCallback } from "react";

import {
  captureMarketingEvent,
  hasAnalyticsConsent,
  isMarketingAnalyticsConfigured,
} from "@/lib/analytics";

type AnalyticsEvent = {
  name: string;
  properties?: Record<string, string | number | boolean>;
};

export const useMarketingAnalytics = () => {
  const track = useCallback((event: AnalyticsEvent) => {
    if (!isMarketingAnalyticsConfigured() || !hasAnalyticsConsent()) return;
    void captureMarketingEvent(event.name, event.properties);
  }, []);

  return { track, isEnabled: isMarketingAnalyticsConfigured() };
};
